jQuery(document).ready(function($){

    //Submit Form
    $('.js-contact-form').submit(function(event) {

        var action_url = '/cms/wp-admin/admin-ajax.php?action=send_contact_form';
        var formData = $(this).serializeArray();

        $.ajax({
            type        : 'POST',
            url         : action_url,
            data        : formData
        }).done(function(data) {

            var message = '';

            if(data == 'true'){
                    message = '<div class="confirmation-overlay"><h2>Vielen Dank für Ihre Nachricht</h2><p>Ich werde mich umgehend bei Ihnen melden.</p></div>';
                    $('.js-contact-form, .module-layotterheadline').hide();
                } else {
                    message = '<div class="confirmation-overlay error"><p><strong>Tut uns leid, leider konnte Ihre E-Mail nicht versendet werden.</strong></p><p>Bitte versuchen Sie es noch einmal.</p></div>';
            }

            $('.confirmation-overlay').remove();

            $('.module-layottercontactform').append(message);

            if(data == 'true') {

                $('html, body').animate({
                    scrollTop: 0
                }, 800);
            }

        });
        event.preventDefault();
    });


});